<template>
  <div class="card vue-avatar-cropper-demo text-center">
    <div class="avatar-cropper">
      <div class="avatar-cropper-overlay" v-if="dataUrl">
        <div class="avatar-cropper-mark">
          <a @click="destroy" class="avatar-cropper-close" href="javascript:;"
            >&times;</a
          >
        </div>
        <div class="avatar-cropper-container">
          <div class="avatar-cropper-image-container">
            <img :src="dataUrl" alt ref="img" @load.stop="createCropper" />
          </div>
          <div class="avatar-cropper-footer">
            <button
              @click.stop.prevent="destroy"
              class="avatar-cropper-btn"
              v-text="labels.cancel"
            >
              Cancel
            </button>
            <button
              @click.stop.prevent="submit"
              class="avatar-cropper-btn"
              v-text="labels.submit"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
      <input :accept="mimes" class="avatar-cropper-img-input" ref="input" />
    </div>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import "cropperjs/dist/cropper.css";
import Cropper from "cropperjs";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import axios from "axios";
// import utils from '@/lib/utils'

export default {
  name: "LogoCrop",
  props: {
    file: {
      type: File
    },
    mimes: {
      type: String,
      default: "image/png, image/gif, image/jpeg, image/bmp, image/x-icon"
    }
  },
  data() {
    return {
      cropperOptions: {
        aspectRatio: 1,
        autoCropArea: 1,
        viewMode: 1,
        movable: false,
        zoomable: false
      },
      cropper: undefined,
      dataUrl: undefined,
      filename: undefined,
      labels: {
        submit: "Submit",
        cancel: "Cancel"
      },
      token: null,
      media_dns: null,
      project_logo: null
    };
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR"
    ])
  },
  methods: {
    ...mapActions([
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "GET_TOKEN_UPLOAD",
      "ON_SHOW_TOAST"
    ]),
    createCropper() {
      this.cropper = new Cropper(this.$refs.img, this.cropperOptions);
    },
    destroy() {
      this.cropper.destroy();
      this.$refs.input.value = "";
      this.dataUrl = undefined;
    },
    submit() {
      this.uploadImage();
      this.destroy();
    },
    convertB64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    async uploadImage() {
      try {
        let base64 = await this.cropper
          .getCroppedCanvas(this.outputOptions)
          .toDataURL();

        let block = base64.split(";");
        let mimeType = block[0].split(":")[1];
        let realData = block[1].split(",")[1];
        let canvasBlob = this.convertB64toBlob(realData, mimeType);
        let img = new File([canvasBlob], this.filename);

        let formData = new FormData();
        formData.append("file", img);
        formData.append("directory", "documents/");
        axios({
          method: "POST",
          timeout: 6000,
          url: this.media_dns + "/api/v1/upload/",
          data: formData,
          headers: { Authorization: `JWT ${this.token}` }
        })
          .then(
            function(res) {
              this.project_logo = res.data.domain + res.data.url;
              this.$emit("project_logo", this.project_logo);
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
            }.bind(this)
          );
      } catch (err) {
        this.ON_SHOW_TOAST({
          message: err,
          styleType: "danger"
        });
      }
    },
    inputFile: function(file) {
      let fileInput = file;
      if (fileInput != null) {
        let reader = new FileReader();
        reader.onload = e => {
          this.dataUrl = e.target.result;
        };

        reader.readAsDataURL(fileInput);

        this.filename = fileInput.name || "unknown";
      }
    }
  },
  mounted() {
    this.GET_TOKEN_UPLOAD()
      .then(
        function(res) {
          this.token = res.token;
          this.media_dns = res.domain;
        }.bind(this)
      )
      .catch(
        function() {
          this.ERROR_TOAST();
        }.bind(this)
      );
  },
  components: {
    "lte-core-alert": LTECoreAlert
  }
};
</script>

<style lang="scss" scoped>
.vue-avatar-cropper-demo {
  max-width: 18em;
  margin: 0 auto;
}
.avatar-cropper {
  .avatar-cropper-overlay {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99999;
  }

  .avatar-cropper-img-input {
    display: none;
  }

  .avatar-cropper-close {
    float: right;
    padding: 20px;
    font-size: 3rem;
    color: #fff;
    font-weight: 100;
    text-shadow: 0px 1px rgba(40, 40, 40, 0.3);
  }

  .avatar-cropper-mark {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.1);
  }

  .avatar-cropper-container {
    background: #fff;
    z-index: 999;
    box-shadow: 1px 1px 5px rgba(100, 100, 100, 0.14);

    .avatar-cropper-image-container {
      position: relative;
      max-width: 400px;
      height: 300px;
    }
    img {
      max-width: 100%;
      height: 100%;
    }

    .avatar-cropper-footer {
      display: flex;
      align-items: stretch;
      align-content: stretch;
      justify-content: space-between;

      .avatar-cropper-btn {
        width: 50%;
        padding: 15px 0;
        cursor: pointer;
        border: none;
        background: transparent;
        outline: none;
        &:hover {
          background-color: #2aabd2;
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Logo/LogoCrop.vue